import { objectToSnake } from "ts-case-convert";

declare global {
  // oxlint-disable-next-line typescript/consistent-type-definitions
  interface Window {
    clarity?: {
      (method: "event", event: string): void;
      (method: "set", key: string, value: string[] | string): void;
    };
    dataLayer?: DataLayerEvent[];
    // eslint-disable-next-line @typescript-eslint/naming-convention
    google_tag_manager?: unknown;
  }
}

type EventPayload = Record<number | string, unknown>;
type DataLayerEvent = EventPayload & { event: string };

function getDataLayer() {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  return window.dataLayer;
}

function submitToClarity(name: string, payload: EventPayload) {
  if (window.clarity) {
    Object.entries(payload).forEach(([key, value]) => {
      window.clarity?.(
        "set",
        key,
        Array.isArray(value) ? value.map(String) : String(value),
      );
    });
    window.clarity("event", name);
  }
}

function createGtmEvent(
  name: string,
  payload: EventPayload = {},
  { timeout = 2000 } = {},
) {
  const snakePayload = objectToSnake(payload);
  const event = { ...snakePayload, event: name };

  submitToClarity(name, snakePayload);

  if (!window.google_tag_manager) {
    getDataLayer().push(event);
    return;
  }

  return new Promise<void>((resolve) => {
    setTimeout(resolve, timeout);

    getDataLayer().push({
      ...event,
      // GTM may invoke eventCallback with no container id.
      eventCallback: (containerId?: string) => {
        if (containerId?.startsWith("GTM-")) {
          resolve();
        }
      },
    });
  });
}

export { createGtmEvent, getDataLayer };
